// extracted by mini-css-extract-plugin
module.exports = {"visually-hidden":"AddToBasket_visually-hidden__WdRGg","button":"AddToBasket_button__ueSVJ"};